import React from "react";

const Header = () => {
  return (
    <header>
      <h1>Calculadora</h1>
    </header>
  );
};

export default Header;
